import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { HeadingImpl } from "./heading.styles.es.js";
const propTypes = {
  as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  children: PropTypes.node.isRequired,
  noWrap: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]).isRequired
};
const defaultProps = {
  as: void 0,
  noWrap: false
};
const Heading = forwardRef(({ as, children, noWrap, size }, ref) => /* @__PURE__ */ jsx(HeadingImpl, { ref, as, $noWrap: noWrap, $size: size, children }));
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;
export {
  Heading
};
